import { useTranslation } from "react-i18next";

export default function Select(props){
            const { t } = useTranslation();
    return(
        <div className="input-block">
            <div>{t(props.label)}:</div>
            <select className="input-small" name={props.name} value={props.value} onChange={props.inputChanged}>
                <option value="">{t('Tout')}</option>
                {props.values.map((x,index)=>
                    <option value={x}>{t(x)}</option>
                )}
            </select>
        </div>
    )
}